module.exports = __webpack_public_path__ + "static/mockup-a514c57cd45bb862e81a6f07f6f74754.png";